var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('router-view'),_c('error-snackbar',{attrs:{"isShow":_vm.error != null,"mesage":_vm.error}}),_c('infomation-snackbar',{attrs:{"isShow":_vm.informationMsg != null,"mesage":_vm.informationMsg}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }